module.exports = __webpack_public_path__ + "static/img/logo-zgc.7842f51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo-zgc.png
// module id = iDXs
// module chunks = 0